import type { ApiClient } from '../../api/client';
import type {
  EmployeeDirectoryPort,
  EmployeeDirectoryProfile,
  EmployeeDirectorySnapshot,
} from '../../features/people/public';

export function createEmployeeDirectoryHttpAdapter(client: ApiClient): EmployeeDirectoryPort {
  return {
    loadDirectory() {
      return client.requestTenant<EmployeeDirectorySnapshot>('/api/hr/v1/{tenant}/employeeDirectory');
    },
    loadProfile(workerId) {
      return client.requestTenant<EmployeeDirectoryProfile>(`/api/hr/v1/{tenant}/employeeDirectory/${encodeURIComponent(workerId)}/profile`);
    },
  };
}
